import script from "./OidoTextInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoTextInput.vue?vue&type=script&setup=true&lang=js"

import "./OidoTextInput.vue?vue&type=style&index=0&id=7a5b2316&scoped=true&lang=css"
import "./OidoTextInput.vue?vue&type=style&index=1&id=7a5b2316&lang=css"
import "./OidoTextInput.vue?vue&type=style&index=2&id=7a5b2316&lang=css"
import "./OidoTextInput.vue?vue&type=style&index=3&id=7a5b2316&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5b2316"]])

export default __exports__